/** @format */

import {ReactElement} from 'react';

import {Trans} from 'react-i18next';

import {ErrorBlockType} from './interfaces';
import {ErrorAdditionalInfo, ErrorDescription, ErrorTitle, StyledErrorBlock} from './styles';

export interface ErrorBlockProps {
  title: string;
  description: string;
  additionalInfo?: ReactElement;
  type?: ErrorBlockType;
  children?: ReactElement;
}

const ErrorBlock = ({
  title,
  description,
  additionalInfo,
  type = 'error',
  children,
}: ErrorBlockProps) => {
  return (
    <StyledErrorBlock type={type}>
      <ErrorTitle type={type}>
        <Trans>{title}</Trans>
      </ErrorTitle>
      <ErrorDescription>
        <Trans>{description}</Trans>
      </ErrorDescription>
      <ErrorAdditionalInfo>{additionalInfo}</ErrorAdditionalInfo>
      {children}
    </StyledErrorBlock>
  );
};

export default ErrorBlock;
